'use strict';

var wishlistGate = require('../wishlist/wishlistGate');

/**
 * appends params to a url
 * @param {string} data - data returned from the server's ajax call
 * @param {Object} button - button that was clicked to add a product to the wishlist
 */
function displayMessage(data, button) {
    if (button.hasClass('product-added')) {
        button.removeClass('b-product_name-fav_button').addClass('b-product_name-fav_selectButton selected');
    } else {
        button.removeClass('b-product_name-fav_selectButton selected').addClass('b-product_name-fav_button');
    }
}

/**
 * Reads the colour value the customer has selected on the PDP.
 *
 * The PLP tile carries `data-variantcolor` on its heart button, but the PDP
 * heart does not — the selected colour lives in the active swatch, not on the
 * button. Without this, the save confirmation resolves the image from the
 * default orderable variant rather than the colour the customer is looking at,
 * which shows the wrong thumbnail (SFCC-7427).
 *
 * @returns {string} the selected colour ID, or an empty string when none is
 *   selected
 */
function getSelectedColor() {
    var $colorAttr = $('.b-product_attrs-item[data-attr="color"]');
    var $selected = $colorAttr.find('ul li a.m-active, ul li a.selected').first();

    if ($selected.length) {
        var value = $selected.attr('data-attr-value');
        if (value !== undefined && value !== '') {
            return value;
        }
    }

    return '';
}

/**
 * Saves the currently selected variation attributes to the URL so they survive
 * the hosted-UI round trip and can be restored on return.
 *
 * On the PDP, selecting a colour and size updates the page via AJAX but does
 * not update the browser URL. The wishlist gate stores
 * window.location.pathname + window.location.search as the intent's originUrl,
 * so without saving the selection here the PDP would load with the default
 * variant after registration — no selected size, and the heart checks the
 * master rather than the saved variant (SFCC-7415).
 *
 * Follows the same pattern as the member-price feature (uarExclusive.js),
 * which uses history.replaceState to persist the selected product state
 * before sending the customer to authenticate.
 */
function saveSelectedVariationsToURL() {
    var urlParams = new URLSearchParams(window.location.search);
    var hasVariations = false;

    $('.b-product_attrs-item[data-attr]').each(function () {
        var attr = $(this).attr('data-attr');
        var splitAttr = $(this).attr('data-split-attr');
        var paramName = 'wl_' + (splitAttr || attr);
        var $selected = $(this).find('ul li a.m-active, ul li a.selected').first();

        if ($selected.length) {
            var value = $selected.attr('data-attr-value');
            if (value !== undefined && value !== '') {
                urlParams.set(paramName, value);
                hasVariations = true;
            }
        }
    });

    if (hasVariations) {
        var hash = window.location.hash || '';
        var url = window.location.pathname + '?' + urlParams.toString() + hash;
        window.history.replaceState({}, '', url);
    }
}

module.exports = {
    addToWishlist: function () {
        $('body').on('click', '.add-to-wish-list', function (e) {
            e.preventDefault();
            var $control = $(this);
            var url = $(this).attr('href');
            var button = $(this).find('.js-whislist-icon');
            var style = $(this).attr('data-analytics-style');
            var sku = $(this).attr('data-analytics-sku');
            var color = $(this).attr('data-analytics-color');
            var pidUrl = $('.b-quantity-select').find(':selected').attr('data-url');
            var result = {};
            if (pidUrl !== null && pidUrl !== undefined) {
                pidUrl.replace(/[?&amp;]+([^=&amp;]+)=([^&amp;]*)/gi, function (str, key, value) {
                    result[key] = value;
                });
            }
            var pid = $(this).attr('data-pid');
            var optionId = $(this).closest('.product-detail').find('.product-option').attr('data-option-id');
            var optionVal = $(this).closest('.product-detail').find('.options-select option:selected').attr('data-value-id');
            optionId = optionId || null;
            optionVal = optionVal || null;
            if (!url || !pid) {
                return;
            }

            var alreadySaved = $(this).find('.js-whislist-icon').hasClass('product-added');

            // Guest login gate. Placed before the request is built and before
            // the icon state is changed, so a gated guest sees no optimistic
            // "saved" state for something that was never saved.
            //
            // The selected variation attributes are saved to the URL first, so
            // the intent's originUrl carries them through the hosted-UI round
            // trip and the PDP can restore them on return (SFCC-7415).
            var variantColor = alreadySaved ? '' : getSelectedColor();

            if (!alreadySaved && wishlistGate.isRequired()) {
                saveSelectedVariationsToURL();
            }
            if (!alreadySaved && wishlistGate.intercept($(this), {
                surface: 'pdp',
                actionType: 'wishlist',
                pid: pid,
                optionId: optionId,
                optionVal: optionVal,
                variantColor: variantColor
            })) {
                return;
            }

            if (alreadySaved) {
                url = $(this).attr('remove-href');
                $(this).find('.js-whislist-icon').removeClass('product-added');
                $.ajax({
                    url: url,
                    type: 'get',
                    dataType: 'json',
                    data: {
                        pid: pid,
                        optionId: optionId,
                        optionVal: optionVal
                    },
                    success: function (data) {
                        displayMessage(data, button);
                        $('body').trigger('wishlist:updateCount', {
                            count: data.wishlistTotal
                        });
                        $('body').trigger('wishlist:removeItemSuccess', {
                            style: style,
                            sku: sku,
                            color: color
                        });
                    },
                    error: function (err) {
                        displayMessage(err, button);
                    }
                });
            } else {
                $(this).find('.js-whislist-icon').addClass('product-added');
                $.ajax({
                    url: url,
                    type: 'post',
                    dataType: 'json',
                    data: {
                        pid: pid,
                        optionId: optionId,
                        optionVal: optionVal,
                        variantColor: variantColor,
                        surface: 'pdp'
                    },
                    success: function (data) {
                        // The gate refused the save. Undo the optimistic fill
                        // before prompting, so the control does not claim a
                        // save that the customer still has to authenticate for,
                        // and skip the analytics events below because nothing
                        // was added.
                        //
                        // Save variation state to the URL here too, because the
                        // page's gate config can be stale (cache hit, expired
                        // session) — the pre-emptive intercept above did not
                        // fire, so the URL was not updated yet.
                        if (data && data.authenticationRequired === true) {
                            saveSelectedVariationsToURL();
                        }
                        if (wishlistGate.handleAuthenticationRequired(data, $control, {
                            surface: 'pdp',
                            actionType: 'wishlist',
                            pid: pid,
                            optionId: optionId,
                            optionVal: optionVal,
                            variantColor: variantColor
                        })) {
                            button.removeClass('product-added');
                            displayMessage(data, button);
                            return;
                        }

                        displayMessage(data, button);
                        wishlistGate.showConfirmation(data);
                        $('body').trigger('wishlist:updateCount', {
                            count: data.wishlistTotal
                        });
                        $('body').trigger('wishlist:addItemSuccess', {
                            style: style,
                            sku: sku,
                            color: color
                        });
                    },
                    error: function (err) {
                        displayMessage(err, button);
                    }
                });
            }
        });
    }
};
